import { backgroundColor, getLabelWidth, horizontalGutter } from 'Components/flowChart/index.style.js';
import styled from 'styled-components';

export const WrapperPopup = styled.div`
	z-index: 201;
	width: 410px;
`;

export const WrapperButton = styled.div<{ isViewMode: boolean }>`
	width: ${({ isViewMode }) => `calc(${getLabelWidth(isViewMode)} + ${horizontalGutter})`};
	position: relative;
	z-index: 2;
	height: 60px;

	.btn-copy {
		top: 18px;
		left: ${({ isViewMode }) => `calc((${horizontalGutter} + ${getLabelWidth(isViewMode)} + 12px) / 2)`};
		position: absolute;
		cursor: pointer;
		background: none;
		border: none;
		padding: 0;
		background-color: ${backgroundColor};
		z-index: 5;

		&:focus {
			outline: 0;
		}

		&.no-data {
			left: 0;
		}

		> .icon-plus-circle {
			display: block;
		}
	}
`;

export const WrapperIcon = styled.div`
	width: 24px;
	height: 24px;
	background-color: #fff;
	border: 1px solid #b8cfe6;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const DropSpace = styled.div`
	position: absolute;
	top: 0px;
	right: -110px;
	width: 160px;
	height: 60px;
	z-index: -1;
`;

export const RadioButton = styled.input`
	margin-top: 0.2rem;
	margin-right: 0.5rem;
	cursor: pointer;
`;

export const Label = styled.label`
	display: block;
	font-size: 14px;
	cursor: pointer;
`;

export const StyledI = styled.i<{ disabled: boolean }>`
	color: ${(props) => (props.disabled ? '#666' : '#005eb8')} !important;
	font-size: 16px !important;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')} !important;
`;
